<template>
  <el-table
    class="k-marathons-list"
    :data="marathons"
    style="width: 100%"
    :row-class-name="tableRowClassName"
  >
    <!-- <el-table-column label="Активна" width="100">
      <template slot-scope="scope">
        <el-tooltip :content="'Акция ' + value" placement="top">
          <el-switch
            v-model="value"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="true"
            inactive-value="false"
            @change="handleChangeActiveStatus()"
          >
          </el-switch>
        </el-tooltip>
      </template>
    </el-table-column> -->

    <el-table-column
      class="k-marathons-list__value"
      prop="_id"
      label="id"
      width="250"
    >
    </el-table-column>

    <el-table-column
      class="k-marathons-list__value"
      prop="title"
      label="Название"
    >
    </el-table-column>

    <el-table-column
      class="k-marathons-list__value"
      prop="title"
      label="Организатор"
    >
      <template slot-scope="scope">
        {{ displayOrganizerTitle(scope.row.organizer) }}
      </template>
    </el-table-column>

   <el-table-column label="Action" width="140">
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.ownStart" content="Учасники" placement="top">
          <el-button @click="handleView(scope.row)" type="info" icon="el-icon-view" circle size="mini"></el-button>
        </el-tooltip>
        <el-tooltip content="Редактировать" placement="top">
          <el-button @click="handleEdit(scope.row)" type="success" icon="el-icon-edit" circle size="mini"></el-button>
        </el-tooltip>
        <el-tooltip content="Удалить" placement="top">
          <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
/**
 * Component: k-marathons-list - Отображает список точек карты

*
* @version 1.0.0
*/

import { mapGetters } from 'vuex';
import formatDate from '@/util/formatDate';


export default {
  name: 'k-marathons-list',

  props: {
    // Массив всех точек
    marathons: {
      type: Array,
    },
  },

  computed: {
    ...mapGetters({
      startsOrganizers: 'starts/startsOrganizers',
    }),
  },

  methods: {
    // Класс для стрки, используется для расскарски строк таблицы в разные цвета
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
      return '';
    },

    getOrganizerTitle(id) {
      return this.startsOrganizers.find(e => e._id === id).title;
    },

    displayOrganizerTitle(id) {
      let organizer = '';

      if (!id) {
        return organizer;
      }

      if (typeof id == 'object') {
        organizer = id.reduce((acc, el, index) => `${acc}${index > 0 ? ', ' : ''}${this.getOrganizerTitle(el)}`, '');
      } else {
        organizer = this.getOrganizerTitle(id);
      }

      return organizer;
    },

    // Редактирование точки
    handleEdit(data) {
      this.$emit('edit', data._id)
    },

    // Удаление точки
    handleDelete(data) {
      this.$emit('delete', data._id);
    },

    handleView({ _id }) {
      this.$router.push(`/marathon-users?id=${_id}`);
    },

    // Форматирование даты
    formatDate,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-points-lis {
  $this: &;

  &__value {
    font-size: 10px;
  }
}
</style>
